import { render, staticRenderFns } from "./FileExtensionIcon.vue?vue&type=template&id=358deb8a&"
import script from "./FileExtensionIcon.vue?vue&type=script&lang=ts&"
export * from "./FileExtensionIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports